import { HttpRequest } from './HttpRequest'


export const GetEmployeeData = async () => {
    try { 
        const response = await HttpRequest().get(`/employee/getname`)
        if (response.data.message === 'OK') {
            const result: any[] = response.data.responseData
            return result
        }
        return []
    } catch (error: any) {
        return []
    }
}
